import React from "react";
import "./WhatWeSolve.css";
import RichTextContent, { CmsText } from "../../../../RichTextContent/RichTextContent";
import { useServiceSection } from "../../../../../context/ServicePageContext";
import { getCardsFromSection } from "../../../../../services/contentApi";

import icon1 from "../../../../../assets/images/services/development/dev1.png";
import icon2 from "../../../../../assets/images/services/development/dev2.png";
import icon3 from "../../../../../assets/images/services/development/dev3.png";
import icon4 from "../../../../../assets/images/services/development/dev4.png";

const icons = [icon1, icon2, icon3, icon4];

const WhatWeSolve = () => {
  const { section, loading } = useServiceSection("what-we-solve");

  if (loading || !section?.fields) return null;

  const fields = section.fields;
  const cards = getCardsFromSection(section, 4);

  return (
    <section className="solve">
      <div className="solve__container">
        {fields.label ? (
          <CmsText
            content={fields.label}
            as="span"
            className="solve__label"
          />
        ) : null}

        {fields.title ? (
          <CmsText content={fields.title} as="h2" />
        ) : null}

        {fields.subtitle ? (
          <CmsText
            content={fields.subtitle}
            as="p"
            className="solve__subtitle"
          />
        ) : null}

        <div className="solve__grid">
          {cards.map((card, i) => (
            <div className="solve__card" key={i}>
              <img src={icons[i]} alt="" />
              <CmsText content={card.title} as="h3" />
              <RichTextContent content={card.description} />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default WhatWeSolve;
